<template>
  <div class="app-container">
    <!-- 标题 -->
    <div class="title-row"><span class="title">{{ this.$route.meta.title }}</span></div>
    <!-- 数据筛选 -->
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
      <el-form-item label="关键字" prop="keyWords">
        <el-input v-model="queryParams.keyWords" placeholder="请输入关键字" clearable  @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item label="登录时间" >
        <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd" type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <el-row :gutter="10" class="mb8">
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList" ></right-toolbar>
    </el-row>
    <!-- 权限列表 -->
    <el-table v-loading="loading" :data="userList" >
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column prop="avatar" label="头像" align="center" width="100">
        <template slot-scope="scope">
          <img :src="scope.row.avatar" width="40" height="40" alt="" />
        </template>
      </el-table-column>
      <el-table-column prop="nickname" label="昵称" align="center" />
      <el-table-column prop="ipAddr" label="ip地址" align="center" width="130px"/>
      <el-table-column prop="ipSource" label="登录地址" align="center" min-width="100" :show-overflow-tooltip="true"/>
      <el-table-column label="设备类型" align="center" prop="deviceType" width="90px" :show-overflow-tooltip="true" />
      <el-table-column label="设备名称" align="center" prop="deviceName" min-width="130px" :show-overflow-tooltip="true" />
      <el-table-column label="操作系统" align="center" prop="os" min-width="110px"/>
      <el-table-column label="代理类型" align="center" prop="agentType" min-width="100px" :show-overflow-tooltip="true" />
      <el-table-column label="代理名称" align="center" prop="agentName" min-width="130px" :show-overflow-tooltip="true" />
      <el-table-column prop="lastLoginTime" label="登录时间" align="center" width="200">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span class="ml4">{{ scope.row.lastLoginTime | dateTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="150">
        <template slot-scope="scope">
          <el-button v-hasPermi="['monitor:online:forceLogout']" size="mini" type="text" icon="el-icon-delete" @click="handleRemoveOnlineUser(scope.row)">下线</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.current"
      :limit.sync="queryParams.size"
      @pagination="getList"
    />
  </div>
</template>

<script>
import { listOnlineUser, removeOnlineUser } from "@/api/system/user";
export default {
  created() {
    this.getList();
  },
  data() {
    return {
      loading: true,
      showSearch:true,
      userList: [],
      dateRange: [],
      queryParams: {
        current: 1,
        size: 10,
        keyWords: null,
        startTime: null,
        endTime: null
      },
      total: 0,
      isCheck: false,
      optLog: {}
    };
  },
  methods: {
    handleQuery(){
      this.queryParams.current = 1;
      this.getList();
    },
    resetQuery(){
      this.dateRange = [];
      this.queryParams.startTime=undefined;
      this.queryParams.endTime=undefined;
      this.resetForm("queryForm");
      this.handleQuery()
    },
    getList() {
      this.loading = true;
      if( Array.isArray(this.dateRange) && this.dateRange.length>0){
        this.queryParams.startTime=this.dateRange[0];
        this.queryParams.endTime=this.dateRange[1];
      }
      listOnlineUser(this.queryParams).then(res => {
        this.userList = res.rows;
        this.total = res.total;
        this.loading = false;
      });
    },
    check(optLog) {
      this.optLog = JSON.parse(JSON.stringify(optLog));
      this.isCheck = true;
    },
    handleRemoveOnlineUser(user) {
      this.$modal.confirm('是否下线昵称为"' + user.nickname + '"的用户？').then(function() {
          return removeOnlineUser(user.token);
        }).then(() => {
          this.getList();
        }).catch(() => {});
    }
  },
  computed: {
    tagType() {
      return function(type) {
        switch (type) {
          case "GET":
            return "";
          case "POST":
            return "success";
          case "PUT":
            return "warning";
          case "DELETE":
            return "danger";
        }
      };
    }
  }
};
</script>
